import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/app/shell/page-header";
import { useFacility } from "@/lib/facility/facility";
import { useCan, useFeature } from "@/lib/policy";
import { guardRoute } from "@/lib/policy/route-guard";
import { GraceAlertsPanel } from "../-components/grace-alerts-panel";
import { GraceSessionsTable } from "../-components/grace-sessions-table";
import { VisitorNav } from "../-components/visitor-nav";

export const Route = createFileRoute("/_authenticated/_visitors/visitors/grace/")({
  beforeLoad: ({ context }) => guardRoute(context.me, "visitors"),
  component: GracePage,
});

/** Grace's side of the door: what needs a person now, then every conversation she had. */
function GracePage() {
  const { facilityId } = useFacility();
  const pinned = facilityId === "all" ? null : facilityId;
  const canManage = useCan("visitor:manage", pinned);
  const graceOn = useFeature("grace", pinned);

  return (
    <div className="flex flex-col gap-5">
      <PageHeader
        title="Grace"
        meta="Her conversations at the kiosk, and what she raised for a person to see."
      />
      <VisitorNav />
      {canManage && graceOn ? <GraceAlertsPanel facilityId={facilityId} /> : null}
      <section aria-labelledby="grace-conversations" className="flex flex-col gap-3">
        <h2 id="grace-conversations" className="text-lg font-semibold tracking-[-0.015em]">
          Conversations
        </h2>
        <GraceSessionsTable facilityId={facilityId} />
      </section>
    </div>
  );
}
